<template>
  <div class="product-details-content-register-module">
    <div class="my-6">
      <step-title
        title="Personalização"
        description="Defina como será a cara da aula para seus alunos."
        icon="fa-solid fa-pen-ruler"
        fa
      />
    </div>

    <div class="pt-5">
      <span>Cartaz horizontal</span>
    </div>
    <div class="row pb-6">
      <input-image
        id="image-horizontal"
        v-model="form.picture"
        title="Cartaz horizontal"
        description="Esta imagem será exibida no módulo"
        dimensions="686x414px"
        class="pt-5 col-lg-5"
      />
      <picture-lesson-mockup
        :image="form.picture"
        class="pt-lg-5 d-none d-lg-block"
      />
    </div>
  </div>
</template>
<script>
import PictureLessonMockup from "@/components/product/member-area/module/PictureLessonMockup";

export default {
  components: {
    PictureLessonMockup
  },
  props: {
    form: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";

.product-details-content-register-module {
  span {
    color: #2b2733;
    font-size: 14px;
  }
  .icon-angle-left {
    font-size: 24px;
    margin-bottom: 3px;
  }
}
</style>
